// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"267":"Setting","268":"Home","330":"Transaction","393":"Card","651":"Errors","726":"Index"}[chunkId] || chunkId) + "." + {"136":"cef4a585","245":"11e9e55d","267":"86d05755","268":"8924b109","330":"07428799","393":"9b24213b","651":"b2c47d07","726":"f59d2a4e"}[chunkId] + ".js";
};